

import React from 'react';

import './style.css';

import { ImportMemberLog } from "../../interface/IImport";
import warningIcon from '../../assets/warning-icon.png';
import infoIcon from '../../assets/info-icon.png';

interface IModalProps {
    message: string,
    importLogs:ImportMemberLog[],
    isOpen: boolean,
    onClose: () => void
}

const ImportLogModal: React.FC<IModalProps> = ({ message,importLogs, isOpen = false, onClose  }) => {


    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content" >
            <div className='center-middle'>
                <div className="icon-size-2">
                    {
                        <img
                            className="responsive-image"
                            src={importLogs.length > 0 ? warningIcon : infoIcon}
                        />
                    }
                </div>
            </div>
            <br />
            <div className='center-middle font-size-17px' style={{ maxHeight:'600px', overflow:'auto'}}>
               {message}
               
               <ul>
                {
                    (importLogs.length > 0) ?
                    importLogs.map((item, index) => (
                       <li key={item.importLogsId ?? index}>
                            {item.membershipId} - {item.message}
                        </li>
                    ))
                   : <li>No logs available</li>
                }
               </ul>

            </div>
            <br />
            <div className="center-middle">
                <button type="button" className='btn-green-2 center-middle' onClick={onClose} >Ok</button>
            </div>
          </div>
        </div>
      );

}

export default ImportLogModal;